"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./HTMLEmbed.scss");
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const HTMLEmbed = _ref => {
  let {
    content,
    paddingClass,
    contentfulId
  } = _ref;
  const {
    HTML,
    header,
    subheader
  } = content;
  const divRef = (0, _react.useRef)(null);
  const [loaded, setLoaded] = (0, _react.useState)(false);
  const [html, setHTML] = (0, _react.useState)(null);
  let isScript = false;
  function findScriptWithSrc(HTML) {
    const re = /<script\b[^>]*>[\s\S]*?<\/script\b[^>]*>/g;
    const arr = HTML?.match(re);
    if (arr) {
      for (let s of arr) {
        if (s?.indexOf('src=') > 1) {
          isScript = true;
          return s;
        }
      }
    }
  }
  function extractAttribs(s) {
    let attribs = {};
    const re = /([\w'-]+)=(?:"([^"]*)"|(\S*))/g;
    let keyval;
    while ((keyval = re.exec(s)) !== null) {
      if (keyval[2]) {
        attribs[keyval[1]] = keyval[2];
      } else {
        attribs[keyval[1]] = keyval[3];
      }
    }
    return attribs;
  }
  const s = HTML && findScriptWithSrc(HTML);
  const a = s && extractAttribs(s);
  const returnRatioClass = () => {
    if (content?.ratio && content?.ratio != null) {
      let ratioClass = `MXP-embed__content-wrapper--ratio`;
      switch (content?.ratio) {
        case "1:1":
          return `${ratioClass} MXP-embed__content-wrapper--ratio-1-1`;
        case "3:4":
          return `${ratioClass} MXP-embed__content-wrapper--ratio-3-4`;
        case "4:3":
          return `${ratioClass} MXP-embed__content-wrapper--ratio-4-3`;
        default:
          return "";
      }
    }
    return "";
  };
  (0, _react.useEffect)(() => {
    if (!isScript) return;
    setHTML(html => HTML.replace(s, ''));
    const script = document.createElement('script');
    for (var k in a) {
      script.setAttribute(k, a[k]);
    }
    script.async = true;
    script.addEventListener('load', () => setLoaded(true));
    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);
  (0, _react.useEffect)(() => {
    if (!loaded) return;
    const range = document.createRange();
    const parsedHTML = range.createContextualFragment(html);
    divRef.current.appendChild(parsedHTML);
  }, [loaded, html]);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `MXP-embed ${paddingClass}`,
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, content?.header && /*#__PURE__*/_react.default.createElement("h3", {
    className: "MXP-embed__header",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header),
    "data-sb-field-path": "header"
  }), content?.subheader && /*#__PURE__*/_react.default.createElement("h5", {
    className: "MXP-embed__subheader",
    "data-sb-field-path": "subHeader"
  }, subheader), loaded && isScript ? /*#__PURE__*/_react.default.createElement("div", {
    className: `MXP-embed__content-wrapper dangerously-set-content ${returnRatioClass()}`,
    ref: divRef,
    "data-sb-field-path": "html"
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: `MXP-embed__content-wrapper dangerously-set-content ${returnRatioClass()}`,
    dangerouslySetInnerHTML: {
      __html: content?.HTML
    },
    "data-sb-field-path": "html"
  }));
};
var _default = HTMLEmbed;
exports.default = _default;